/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div id='home-bg'>
    <!--canvas背景-->
    <Background></Background>
    <!--头部-->
    <Header :projectInfo="projectInfo"></Header>
    <!--日周月报警信息-->
    <TicketStatChart :day="day" :week="week" :month="month"></TicketStatChart>
    <!--报警信息-->
    <AlarmMonitor :data="latestAlarm"></AlarmMonitor>
    <!--配电箱数据-->
    <BoxInformation :data="selectedBox"></BoxInformation>
    <!-- 电压 -->
    <VoltageGrid :data="voltageData"/>
    <!-- 电流 -->
    <CurrentGrid :data="currentData"/>
    <!-- 负荷分布 -->
    <CurrentBoxMetric :data="boxMetric"/>
    <!-- 漏电 -->
    <LeakageGrid :data="leakageData"/>
    <!-- 电量 -->
    <EnergyGrid :data="energyData"/>
    <!-- 温度 -->
    <TemperatureGrid :data="temperatureData"/>
    <!--3D配电箱-->
    <ThreeDBox :boxes="boxes" :runData = 'runData' :config="areaConfig" :screenChange="isScreenChange" @initFinish="requestMetricData" @clickBox="clickBox"></ThreeDBox>
  </div>
</template>

<script>
import $ from 'jquery'
import dayjs from 'dayjs'
import Background from '@/components/Background'
import Header from '@/components/Header'
import TicketStatChart from '@/components/TicketStatChart'
import AlarmMonitor from '@/components/AlarmMonitor'
import VoltageGrid from '@/components/VoltageGrid'
import CurrentGrid from '@/components/CurrentGrid'
import CurrentBoxMetric from '@/components/CurrentBoxMetric'
import LeakageGrid from '@/components/LeakageGrid'
import EnergyGrid from '@/components/EnergyGrid'
import BoxInformation from '@/components/BoxInformation'
import TemperatureGrid from '@/components/TemperatureGrid'
import ThreeDBox from '@/components/ThreeDBox'
import {
  getProjectInfo,
  getTicketDay,
  getTicketWeek,
  getTicketMonth,
  getBoxMetric,
  getMetric,
  getSeries,
  getLatestAlarm
} from '@/api/metric'
import { formatterNumber, transPingTreeToChildren } from '@/utils/utils'
const dateFormate = 'YYYY-MM-DD HH:mm:ss'
const alarmContent = {'is_overload': '过载', 'is_smoke': '烟感', 'is_overheat': '高温', 'is_disconnect': '断开', 'is_blackout': '断电', 'is_leakage': '漏电'}
export default {
  name: 'home',
  data () {
    return {
      index: 0, // 配电箱列表的下标 根据点击配电箱的更改下标
      token: null,
      projectHashId: null, // 项目id
      // 项目信息
      projectInfo: {
        name: '', // 项目名称
        intro: '', // 项目简介
        boxTotal: 0, // 配电箱总数
        onlineTotal: 0 // 在线数
      },
      boxPosition: {},
      // 报警统计
      day: [],
      week: [],
      month: [],
      voltageData: [], // 电压数据
      currentData: [], // 电流数据
      leakageData: [],
      energyData: [], //
      temperatureData: [], // 温度数据
      boxMetric: [],
      // 当前选择配电箱
      selectedBox: {}, // 当前选择的配电箱
      latestAlarm: {
        data: [],
        rowNum: 12, // 实时报警行数
        oddRowBGC: 'rgba(50, 211, 235, 0.03)', // 奇数行颜色
        evenRowBGC: 'rgba(14,33,69,0)', // 偶数行颜色
        columnWidth: [150, 250, 80] // 数据宽度
      },
      areaConfig: null,
      boxOrgList: [], // 所有配电箱数据
      boxes: [],
      runData: [],
      runDataTimer: null, // 实时数据的轮询
      trendTimer: null, // 趋势数据的轮询
      staticTimer: null, // 统计数据的轮询
      isScreenChange: Math.random()
    }
  },
  components: {
    BoxInformation,
    Background,
    Header,
    TicketStatChart,
    AlarmMonitor,
    VoltageGrid,
    CurrentBoxMetric,
    CurrentGrid,
    LeakageGrid,
    EnergyGrid,
    TemperatureGrid,
    ThreeDBox
  },
  methods: {
    // 获取配电箱列表
    getProjectData () {
      getProjectInfo(this.projectHashId, this.token).then(res => {
        const {code, result} = res
        if (code === 200) {
          const newResult = result.filter((item) => !!item.device)
          if (newResult.length) {
            this.boxOrgList = newResult
            this.index = 0
            this.selectedBox = newResult[0] // 开始先选择配电箱列表第一条数据
            this.closeTrend()
            this.requestTrend() // 获取趋势和电流负荷
            this.requestTrendTimer() // 一分钟切换一个配电箱数据
            this.getLatestAlarm() // 获取实时报警数据
            this.calcPosition(newResult) // 处理配电箱的位置
            this.resolveBoxData(newResult) // 处理配电箱列表
          }
        }
      })
    },
    // 点击配电箱更新趋势数据
    clickBox (hashId) {
      const clickBox = this.boxOrgList.filter((res, index) => {
        if (res.hashId === hashId) {
          this.index = index
          return res
        }
      })
      if (clickBox.length) {
        this.closeTrend()
        this.selectedBox = clickBox[0]
        this.requestTrend()
        this.requestTrendTimer()
      }
    },
    requestTrendTimer () {
      //  如果没有点击 一分钟切换一个配电箱的数据
      this.trendTimer = setInterval(() => {
        this.index++
        if (this.index < this.boxOrgList.length) {
          this.selectedBox = this.boxOrgList[this.index]
          this.requestTrend() // 获取趋势和电流负荷
        } else {
          this.selectedBox = this.boxOrgList[0]
          this.requestTrend()
        }
      }, 60000)
    },
    requestTrend () {
      this.getTrend() // 获取趋势
      this.getCurrentMetric() // 获取电流负荷
    },
    // 处理配电箱的位置
    calcPosition (result) {
      // 独立配电箱、两级配电箱、三级配电箱
      // 暂定独立配电箱的11个开始换行
      const resultObj = {}
      const boxSideDis = 700, BeforeAndAfter = 600, baseBoxesNum = 7 // 最好是奇数
      const singleBoxes = [], twoBoxes = [], threeBoxes = []
      const newResult = [...result, ...[]]
      const treeArray = transPingTreeToChildren(newResult, { // 除去三个children配电箱的所有配电箱
        id: 'hashId',
        pid: 'parentBoxHashId',
        children: 'children'
      })
      treeArray.forEach((res) => {
        const {parentBoxHashId, children} = res // parentBoxHashId:children箱子才有parentBoxHashId   children:A6 箱子的三个children
        if (!parentBoxHashId && !children) {
          singleBoxes.push(res) // 独立配电箱 没有children
        } else {
          let hasThreeBox = false
          children.forEach((chld) => {
            const {children: nextChildren} = chld
            if (nextChildren) {
              hasThreeBox = true
            }
          })
          if (hasThreeBox) threeBoxes.push(res) // 无三级
          else twoBoxes.push(res) // 两级配电箱 A6
        }
      })
      const {length: singleBoxLen} = singleBoxes
      const {length: twoBoxLen} = twoBoxes
      const {length: threeBoxLen} = threeBoxes
      // 先确定独立配电箱空间
      const singleRow = Math.floor(singleBoxLen / baseBoxesNum) // 3行
      const singleExtraBox = singleBoxLen % baseBoxesNum // 余1
      // 独立配电箱在Z轴的距离
      const singleHeight = singleRow * BeforeAndAfter + (!singleExtraBox ? 0 : BeforeAndAfter)
      const twoHeight = singleRow * BeforeAndAfter + (!singleExtraBox ? 0 : BeforeAndAfter) + (!twoBoxLen ? 0 : BeforeAndAfter * 2)
      const num = singleRow + (!singleExtraBox ? 0 : 1) + (!twoBoxLen ? 0 : 2) + (!threeBoxLen ? 0 : 3)
      const halfNum = (num - 1) / 2 // 1
      const allBeginZ = -BeforeAndAfter * halfNum
      // 处理整行配电箱
      for (let i = 0; i < singleRow; i++) {
        const beginIndex = i * baseBoxesNum
        const endIndex = beginIndex + baseBoxesNum - 1
        const beginX = -boxSideDis * (baseBoxesNum - 1) / 2
        const zDis = i * BeforeAndAfter + allBeginZ
        singleBoxes.filter((item, index) => index >= beginIndex && index <= endIndex).forEach((item, index) => {
          const {hashId} = item
          resultObj[hashId] = {x: (beginX + index * boxSideDis), z: zDis}
        })
      }
      // 处理剩余的独立配电箱
      if (singleExtraBox) {
        const beginIndex = singleRow * baseBoxesNum
        const zDis = singleRow * BeforeAndAfter + allBeginZ // 600
        const extraArray = singleBoxes.filter((item, index) => index >= beginIndex)
        let beginX = -boxSideDis * (singleExtraBox - 1) / 2
        extraArray.forEach((item, index) => {
          const {hashId} = item
          resultObj[hashId] = {x: (beginX + index * boxSideDis), z: zDis}
        })
      }
      // 处理二级箱
      if (twoBoxLen) {
        let twoChildren = []
        twoBoxes.forEach((twoBox) => {
          const {children} = twoBox
          twoChildren = [...twoChildren, ...children]
        })
        const {length} = twoChildren
        const zDis = singleHeight + BeforeAndAfter + allBeginZ
        let beginX = -boxSideDis * (length - 1) / 2
        twoChildren.forEach((item, index) => {
          const {hashId} = item
          resultObj[hashId] = {x: (beginX + index * boxSideDis), z: zDis}
        })
        twoBoxes.forEach((twoBox) => {
          const {hashId, children} = twoBox
          const {length} = children
          const {hashId: childrenHashId} = children[0]
          const x = resultObj[childrenHashId].x + (length - 1) / 2 * boxSideDis
          const z = singleHeight + allBeginZ
          resultObj[hashId] = {x, z}
        })
      }
      // 处理三级箱
      if (threeBoxLen) {
        let threeChildren = []
        threeBoxes.forEach((threeBox, topIndex) => {
          const {children} = threeBox
          children.forEach((child, index) => {
            const {hashId: threeHashId, children: threeChild} = child
            if (threeChild) {
              threeChildren = [...threeChildren, ...threeChild]
            } else {
              const newArray = [{hashId: `temporary${index}`, parentBoxHashId: threeHashId}]
              threeBoxes[topIndex].children[index].children = newArray
              threeChildren = [...threeChildren, ...newArray]
            }
          })
        })
        const {length} = threeChildren
        const zDis = twoHeight + BeforeAndAfter * 2 + allBeginZ
        let beginX = -boxSideDis * (length - 1) / 2
        threeChildren.forEach((item, index) => {
          const {hashId} = item
          resultObj[hashId] = {x: (beginX + index * boxSideDis), z: zDis}
        })
        threeBoxes.forEach((threeBox) => {
          const {hashId, children} = threeBox
          children.forEach((res) => {
            const {hashId: secondHashId, children: secondChild} = res
            const {length: threeLen} = secondChild
            const {hashId: thirdHashId} = secondChild[0]
            const x = resultObj[thirdHashId].x + (threeLen - 1) / 2 * boxSideDis
            const z = twoHeight + BeforeAndAfter + allBeginZ
            resultObj[secondHashId] = {x, z}
          })
          const {length} = children
          const {hashId: secondHashId} = children[0]
          const x = resultObj[secondHashId].x + (length - 1) / 2 * boxSideDis
          const z = twoHeight + allBeginZ
          resultObj[hashId] = {x, z}
        })
      }
      this.boxPosition = resultObj
    },
    // 处理配电箱列表
    resolveBoxData (result) {
      let onlineTotal = 0
      const obj = {}
      const boxes = []
      const xArray = [], zArray = []
      const {name, intro, boxTotal} = result[0].project
      const resolveBoxes = result.filter((obj) => this.boxPosition[obj.hashId]).map((obj) => {
        const position = this.boxPosition[obj.hashId]
        return {...obj, ...position}
      })
      resolveBoxes.forEach((res) => {
        if (!obj[res.hashId]) {
          obj[res.hashId] = res
        }
      })
      resolveBoxes.forEach((res) => {
        let newObj = {}
        const {hashId, name, device: {onlineStatus}, level, x, z, parentBoxHashId} = res
        xArray.push(x)
        zArray.push(z)
        newObj = {...newObj, ...{hashId, name, level, x, z}}
        if (parentBoxHashId && obj[parentBoxHashId]) {
          const parentObj = obj[parentBoxHashId]
          const {level: pLevel, x: pX, z: pY} = parentObj
          newObj.parentBox = {level: pLevel, x: pX, z: pY, linePath: null}
        } else {
          newObj.parentBox = null
        }
        if (onlineStatus) {
          onlineTotal++
        }
        boxes.push(newObj)
      })
      const maxX = Math.abs(Math.max(...xArray))
      const minX = Math.abs(Math.min(...xArray))
      const maxZ = Math.abs(Math.max(...zArray))
      const minZ = Math.abs(Math.min(...zArray))
      const areaResult = Math.max(maxX, minX, maxZ, minZ) * 2
      this.areaConfig = areaResult < 1000 ? 1000 : areaResult
      this.boxes = boxes
      this.projectInfo = {name, intro, boxTotal, onlineTotal}
    },
    requestMetricData () {
      this.closeRunData()
      this.getMetricData()
      this.runDataRequest()
    },
    // 获取配电箱实时数据
    getMetricData () {
      const data = []
      let onlineTotal = 0
      getMetric(this.projectHashId).then(res => {
        const {code, result} = res
        if (code === 200) {
          result.forEach((item) => {
            const alarmArray = []
            const {boxHashId, onlineStatus, ticketStatus, metric, switches: {ac = ''}, temperatures} = item
            const {current_a, current_b, current_c, voltage_a, voltage_b, voltage_c, energy_a, energy_b, energy_c} = metric
            const {is_overload, is_smoke, is_overheat, is_disconnect, is_blackout, is_leakage} = ticketStatus
            const energy = formatterNumber(energy_a + energy_b + energy_c)
            const acArray = ac.split(',')
            // ac的状态是0和1相反
            const switchUpStatus = acArray.length ? !parseInt(acArray[0]) : false
            let temperature = '-'
            if (temperatures && temperatures.length) {
              const len = temperatures.length
              let temperSum = 0
              temperatures.forEach((obj) => {
                temperSum += obj.temperature
              })
              temperature = formatterNumber(temperSum / len)
            }
            if (parseInt(is_overload)) alarmArray.push(alarmContent['is_overload'])
            if (parseInt(is_smoke)) alarmArray.push(alarmContent['is_smoke'])
            if (parseInt(is_overheat)) alarmArray.push(alarmContent['is_overheat'])
            if (parseInt(is_disconnect)) alarmArray.push(alarmContent['is_disconnect'])
            if (parseInt(is_blackout)) alarmArray.push(alarmContent['is_blackout'])
            if (parseInt(is_leakage)) alarmArray.push(alarmContent['is_leakage'])
            if (onlineStatus) onlineTotal++
            data.push({hashId: boxHashId, hasCurrent: switchUpStatus, isOnline: Boolean(onlineStatus), infoPlaneObj: {current_a, current_b, current_c, voltage_a, voltage_b, voltage_c, energy, temperature, alarmContent: alarmArray}})
          })
          this.projectInfo = {...this.projectInfo, ...{onlineTotal}}
          this.runData = data
        }
      })
    },
    runDataRequest () {
      this.runDataTimer = setInterval(() => {
        this.getMetricData() // 获取配电箱实时数据
        this.getLatestAlarm() // 获取实时报警数据
      }, 300000) // 5分钟轮询一次
    },
    // 获取日、周、月报警统计
    getDayWeekMonth () {
      getTicketDay(this.projectHashId).then((day) => {
        const {code, result: {boxes}} = day
        if (code === 200) {
          this.day = this.resolveDayWeekMonth(boxes)
        }
      })
      getTicketWeek(this.projectHashId).then((week) => {
        const {code, result: {boxes}} = week
        if (code === 200) {
          this.week = this.resolveDayWeekMonth(boxes)
        }
      })
      getTicketMonth(this.projectHashId).then((month) => {
        const {code, result: {boxes}} = month
        if (code === 200) {
          this.month = this.resolveDayWeekMonth(boxes)
        }
      })
    },
    resolveDayWeekMonth (data) {
      const dayArr = []
      data.forEach(res => {
        const {name, short_circuit, smoke, overheat, leakage, blackout, overload, disconnect, resi} = res
        dayArr.push({name, type: '短路', value: short_circuit})
        dayArr.push({name, type: '烟感', value: smoke})
        dayArr.push({name, type: '高温', value: overheat})
        dayArr.push({name, type: '漏电', value: leakage})
        dayArr.push({name, type: '断电', value: blackout})
        dayArr.push({name, type: '过载', value: overload})
        dayArr.push({name, type: '断开', value: disconnect})
        dayArr.push({name, type: '接地', value: resi})
      })
      return dayArr
    },
    staticRequest () {
      this.staticTimer = setInterval(() => {
        this.getDayWeekMonth()
      }, 600000) // 10分钟轮询一次
    },
    // 获取趋势
    getTrend () {
      const current = dayjs()
      const endDateTime = current.format(dateFormate)
      const startDateTime = current.subtract(1, 'd').format(dateFormate)
      const {hashId, device: {leakageStatus, temperatureStatus}} = this.selectedBox
      const params = {boxHashId: hashId, duration: 'day', startTime: startDateTime, endTime: endDateTime, fill: 'previous'}
      // 获取电压、电流、电量趋势
      let newParams = {...params, ...{genre: 'energy'}}
      getSeries(newParams, this.token).then(res => {
        const voltage = [], current = [], energy = []
        res.result.serie.forEach(pre => {
          const {time, voltage_a, voltage_b, voltage_c, current_a, current_b, current_c, energy_a, energy_b, energy_c} = pre
          voltage.push({name: 'A相', time: time, value: voltage_a})
          voltage.push({name: 'B相', time: time, value: voltage_b})
          voltage.push({name: 'C相', time: time, value: voltage_c})
          current.push({name: 'A相', time: time, value: current_a})
          current.push({name: 'B相', time: time, value: current_b})
          current.push({name: 'C相', time: time, value: current_c})
          energy.push({name: 'A相', time: time, value: energy_a})
          energy.push({name: 'B相', time: time, value: energy_b})
          energy.push({name: 'C相', time: time, value: energy_c})
        })
        this.voltageData = voltage
        this.currentData = current
        this.energyData = energy
      })
      // 获取漏电趋势
      newParams = {...params, ...{genre: 'leakage'}}
      getSeries(newParams, this.token).then(res => {
        const leakage = [], leakageKey = []
        const leakageStatusArr = leakageStatus.split(',')
        leakageStatusArr.forEach((res, index) => {
          const currentIndex = index + 1
          if (parseInt(res)) leakageKey.push({key: `leakage_${currentIndex}`, name: `${currentIndex}分路`})
        })
        res.result.serie.forEach(pre => {
          leakageKey.forEach(res => {
            leakage.push({name: res.name, time: pre.time, value: pre[res.key]})
          })
        })
        this.leakageData = leakage
      })
      // 获取温度趋势
      newParams = {...params, ...{genre: 'temperature'}}
      getSeries(newParams, this.token).then(res => {
        const temperature = [], temperatureKey = []
        const temperatureStatusArr = temperatureStatus.split(',')
        temperatureStatusArr.forEach((res, index) => {
          const currentIndex = index + 1
          if (parseInt(res)) temperatureKey.push({key: `t_${currentIndex}`, name: `${currentIndex}分路`})
        })
        res.result.serie.forEach(pre => {
          temperatureKey.forEach(res => {
            temperature.push({name: res.name, time: pre.time, value: pre[res.key]})
          })
        })
        this.temperatureData = temperature // 温度数据
      })
    },
    // 获取电流负荷
    getCurrentMetric () {
      const {hashId, ratedCurrent} = this.selectedBox
      getBoxMetric(hashId).then(res => {
        const metric = []
        const {A, B, C} = res.result
        const pre = Math.round(ratedCurrent / 11)
        const aResult = this.resolveCurrentMetric(A)
        aResult.forEach((res, index) => {
          if (index < 10) metric.push({name: 'A相', type: `${pre * index}~${pre * (index + 1)}A`, value: res})
          else metric.push({name: 'A相', type: `${pre * 10}~${ratedCurrent}A`, value: res})
        })
        const bResult = this.resolveCurrentMetric(B)
        bResult.forEach((res, index) => {
          if (index < 10) metric.push({name: 'B相', type: `${pre * index}~${pre * (index + 1)}A`, value: res})
          else metric.push({name: 'B相', type: `${pre * 10}~${ratedCurrent}A`, value: res})
        })
        const cResult = this.resolveCurrentMetric(C)
        cResult.forEach((res, index) => {
          if (index < 10) metric.push({name: 'C相', type: `${pre * index}~${pre * (index + 1)}A`, value: res})
          else metric.push({name: 'C相', type: `${pre * 10}~${ratedCurrent}A`, value: res})
        })
        this.boxMetric = metric
      })
    },
    // 处理分布
    resolveCurrentMetric (obj) {
      const metric = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110]
      const result = []
      metric.forEach((res) => {
        result.push(parseInt(obj[`p${res}`] / 86400 * 100))
      })
      return result
    },
    // 获取实时报警数据
    getLatestAlarm () {
      getLatestAlarm(this.projectHashId).then(res => {
        const data = []
        res.result.forEach((obj) => {
          const {created, message, boxname} = obj
          data.push([created, message, boxname])
        })
        this.latestAlarm = {...this.latestAlarm, ...{data}}
      })
    },
    init () {
      let auth = sessionStorage.getItem('auth')
      let projectHashId = sessionStorage.getItem('projectHashId')
      if (!auth || !projectHashId) {
        const params = this.getUrlParams()
        auth = params.token
        projectHashId = params.hashId
        if (!auth || !projectHashId) {
          this.$router.push('/')
        } else {
          this.token = auth
          this.projectHashId = projectHashId // 项目id
          this.getProjectData() // 获取配电箱的列表数据
          this.closeStaticTimer() // 判断定时器是否开启 如果是开启状态就清除定时器
          this.getDayWeekMonth() // 获取日周月的报警数据
          this.staticRequest() // 十分钟再获取一次报警数据
        }
      } else {
        this.token = auth
        this.projectHashId = projectHashId
        this.getProjectData()
        this.closeStaticTimer()
        this.getDayWeekMonth()
        this.staticRequest()
      }
    },
    // 获取url参数
    getUrlParams () {
      const params = {}
      const href = window.location.href
      const searchIndex = href.indexOf('?')
      if (searchIndex > -1) {
        const search = href.substring(searchIndex + 1)
        const paramsStr = search.split('&')
        paramsStr.forEach(res => {
          const str = res.split('=')
          params[str[0]] = str[1]
        })
      }
      return params
    },
    // 铺满全屏
    resizeFull () {
      const ratioX = window.innerWidth / 1920
      const ratioY = window.innerHeight / 1080
      $('#home-bg').css({
        transform: 'scale(' + ratioX + ', ' + ratioY + ')',
        transformOrigin: 'left top',
        backgroundSize: '100% 100%'
      })
    },
    addEvenListener () {
      const self = this
      window.onresize = function () {
        self.isScreenChange = Math.random()
        self.resizeFull()
      }
    },
    closeTrend () {
      if (this.trendTimer) clearInterval(this.trendTimer)
    },
    closeRunData () {
      if (this.runDataTimer) clearInterval(this.runDataTimer)
    },
    closeStaticTimer () {
      if (this.staticTimer) clearInterval(this.staticTimer)
    }
  },
  mounted () {
    this.addEvenListener()
    this.resizeFull()
    this.init()
  },
  destroyed () {
    this.closeTrend()
    this.closeRunData()
    this.closeStaticTimer()
  }
}
</script>

<style scoped lang="scss">
  #home-bg{
    width:1920px;
    height:1080px;
    position: relative;
    .fullScreen{
      position: absolute;
      right: 5px;
      bottom: 5px;
      cursor: pointer;
      z-index: 2;
      img{
        width: 32px;
        opacity: 0.5;
        transition: opacity .2s ease-in-out;
      }
      img:hover{
        opacity: 1;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue